export var UploadMethod;
(function (UploadMethod) {
    UploadMethod[UploadMethod["Manual"] = 1] = "Manual";
    UploadMethod[UploadMethod["Email"] = 2] = "Email";
    UploadMethod[UploadMethod["ExternalFile"] = 3] = "ExternalFile";
    UploadMethod[UploadMethod["Stock"] = 4] = "Stock";
})(UploadMethod || (UploadMethod = {}));
